import { endRoute, parentRoute } from '$shared/utils/routes';

export const assessmentReportRoutes = {
  assessmentReport: parentRoute('/assessment-report')({
    backToSchoolReport: endRoute<{ id: string }>('/assessment-report/back-to-school/:id'),
    holidayReport: endRoute<{ id: string }>('/assessment-report/holiday/:id'),
  }),
};
